import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import {
    sliderContainer,
    sliderContent,
    slide,
    navBtn,
    prev,
    next,
    padlock
} from "./image-slider-simple.module.scss";
import { IProduct } from "../../models/product.model";
import useUser from "../../apps/auth/hooks/use-user";
import PadlockClosed from "../../assets/images/svg/padlock-closed.svg";
import PadlockOpen from "../../assets/images/svg/padlock-open.svg";
import { useFormikContext } from "formik";
import { IGeneratorFormValues, TBlockedProduct } from "../../models/generator.model";
import { postProductStatistic} from '../../services/product-services';

interface ImageSliderSimpleProps {
    products: string[];
    onSlideUp?: () => void;
    surveyPopup: boolean;
    isLoggedIn: boolean;
}

interface SlideProps {
    product: string;
    index: number;
    currentIndex: number;
    isLoggedIn: boolean;
}

const Slide: React.FC<SlideProps> = React.memo(
    ({ product, index, currentIndex, isLoggedIn }) => (
        <div
            className={`${slide} ${index === currentIndex ? "active" : ""}`}
            style={{ transform: `translateX(-${currentIndex * 100}%)`, backgroundImage: `url("${product}")` }}
        >
            &nbsp;
            {/* <img src={product} alt={`Slide ${index}`} /> */}
        </div>
    )
);
const ImageSliderSimple: React.FC<ImageSliderSimpleProps> = ({ products, onSlideUp, surveyPopup, isLoggedIn }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const touchStartX = useRef(0);
    const touchStartY = useRef(0);
    const sliderRef = useRef<HTMLDivElement>(null);
    const formik = useFormikContext<IGeneratorFormValues>();

    const nextSlide = useCallback(() => {
        setCurrentIndex((prev) => (prev === products.length - 1 ? 0 : prev + 1));
    }, [products.length]);

    const prevSlide = useCallback(() => {
        setCurrentIndex((prev) => (prev === 0 ? products.length - 1 : prev - 1));
    }, [products.length]);

    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
        touchStartX.current = e.touches[0].clientX;
        touchStartY.current = e.touches[0].clientY;
    };

    const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
        if (!sliderRef.current) return;

        const touchCurrentY = e.touches[0].clientY;
        const deltaY = touchStartY.current - touchCurrentY;

        // Blokuj przewijanie tylko gdy przesunięcie jest głównie pionowe
        if (Math.abs(deltaY) > 10) {
            e.preventDefault();
        }
    };

    const handleTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
        const touchEndX = e.changedTouches[0].clientX;
        const touchEndY = e.changedTouches[0].clientY;
        const deltaX = touchStartX.current - touchEndX;
        const deltaY = touchStartY.current - touchEndY;

        if (deltaY > 50 && onSlideUp) {
            console.log("generate new");
            if (surveyPopup) {
                return;
            }
            onSlideUp();
        } else if (Math.abs(deltaX) > Math.abs(deltaY)) {
            // Wykonuj przesuwanie w poziomie tylko jeśli ruch był bardziej poziomy niż pionowy
            if (deltaX > 50) {
                console.log("Swiped Left");
                prevSlide();
            } else if (deltaX < -50) {
                console.log("Swiped Right");
                nextSlide();
            }
        }
    };
    
    useEffect(() => {
        const currentSliderRef = sliderRef.current;
        if (currentSliderRef) {
            currentSliderRef.addEventListener('touchmove', handleTouchMove as any, { passive: false });
        }
        return () => {
            if (currentSliderRef) {
                currentSliderRef.removeEventListener('touchmove', handleTouchMove as any);
            }
        };
    }, []);

    useEffect(() => {
        console.log("products", products);
    }, [products]);

    return (
        <div
            ref={sliderRef}
            className={sliderContainer}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
        >
            <div className={sliderContent}>
                {products.map((product, index) => (
                    <Slide
                        key={index}
                        product={product}
                        index={index}
                        isLoggedIn={isLoggedIn}
                        currentIndex={currentIndex}
                    />
                ))}
            </div>

            {products.length>1 && <button type="button" className={`${navBtn} ${prev}`} onClick={prevSlide}>
                &#10094;
            </button>}
            {products.length>1 && <button type="button" className={`${navBtn} ${next}`} onClick={nextSlide}>
                &#10095;
            </button>}
        </div>
    );
};

function getIsLocked(blockedProducts: TBlockedProduct[], product: IProduct) {
    return blockedProducts.map((product) => product.productId).includes(product.productId);
}

export default ImageSliderSimple;
